import script from "./hardware-change-record-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./hardware-change-record-list.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__